import React, { useEffect, useState } from "react";
import postal from 'postal';
import IfmsModal from "../IfmsModal";
import TextBox from "../TextBox";
import Date from '../Date';
import SecondaryButton from "../SecondaryButton";
import { useTypedFastStorage } from "../../hooks/useFastStorage";
import useFunctionKeys from "../../hooks/useFunctionKeys";
import Float from "../Float";

export function TableSearch({
  searchField,
  searchValue,
  onCancel,
  onSave,
  ...other
}: any) {


  const [showTableSearchConfiguration, setTableSearchConfiguration] = useState(false);
  const [fieldType, setFieldType] = useState<string>('');

  const [search, setSearch, , searchRef] = useTypedFastStorage<string>(`ifms-table-search-value`, null);
  const searchValueChannel = postal.channel('ifms-table-search-value');
  let openSubscription: ISubscriptionDefinition<any> | null = null;
  useFunctionKeys({ onEsc: search ? cancel : undefined});

  function cancel() {
    setTableSearchConfiguration(false);
    setSearch('');
    return true;
  }

  useEffect(() => {
    subscribeChannels();

    return () => {
      unsubscribeChannels();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function subscribeChannels() {
    openSubscription = postal.subscribe({
      channel: 'ifms-table-search',
      topic: 'ifms-table-search.open',
      callback: ({ columnId, value, numValue, type, cur }) => {
        if (type === 'checkbox' || columnId === undefined) {
          setTableSearchConfiguration(false);
          return;
        }
        else if (type === 'date') setFieldType('date');
        else if (type === 'number') setFieldType('number');
        else setFieldType('text');
        setTableSearchConfiguration(true);
      },
    });

  }

  function unsubscribeChannels() {
    if (openSubscription) {
      postal.unsubscribe(openSubscription);
    }
  }

  function onEnter() {
    if (searchRef && searchRef.current) {
      if(searchRef.current !== ''){
        setSearch(searchRef.current);
      }
    }
    // console.log('onEnter : '+ search);
    searchRowCell();
  }

  function searchRowCell() {
    searchValueChannel.publish('ifms-table-search-value.search', { value: (searchRef && searchRef.current) ? searchRef.current : search, field : fieldType});
    setSearch('');
    setTableSearchConfiguration(false);
  }

  function focusEntry() {
    const dataEntryContainer = document.getElementById('table-search-field');
    if (!dataEntryContainer) {
      return;
    }
    if (dataEntryContainer) {
      let focusNode:any = null;
      const tabableElements = dataEntryContainer.querySelectorAll('.ifms-tabable-active');
      if (tabableElements && tabableElements.length > 0) {
        focusNode = tabableElements[0];
      }
      if (focusNode) {
        if (focusNode.focus) {
          focusNode.focus();
        }
        if (focusNode.select) {
          focusNode.select();
        }
      }
    }
  }

  return (
    <div>
      <IfmsModal isBlueHeader onCancel={cancel} cancelOnEsc draggable isOpen={showTableSearchConfiguration} title="Search" width="380px" onShow={focusEntry}>
        <div className='report-popup'>
          <div id='table-search-field' style={{ height: '35px' }}>
            {fieldType === 'date' &&
              <div style={{ width: '80px', marginLeft: '105px' }}>
                <Date name='ifms-table-filter-searchDateBox' dateId='ifms-table-filter-searchDateBox'
                  style={{ height: '25px' }}
                  value={search}
                  onChange={date => setSearch(date?.toString() ?? '')}
                  onEnter={onEnter}
                />
              </div>
            }
            {fieldType === 'number' &&
              <div style={{ width: '290px' }}>
                <Float
                  style={{ height: '25px' }}
                  floatId="ifms-table-filter-float"
                  value={parseFloat(search ?? '')}
                  onChange={e => setSearch((e ?? 0).toString())}
                  onEnter={onEnter}
                  decimals={4}
                />
              </div>
            }
            {fieldType === 'text' &&
              <div style={{ width: '290px' }}>
                <TextBox
                  style={{ height: '25px' }}
                  name='ifms-table-filter-searchTextBox'
                  textId="ifms-table-filter"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  onEnter={onEnter}
                //onBlur={onBlur}
                />
              </div>
            }
          </div>
          <div className='report-footer'>
            <SecondaryButton
              name='ifms-table-filter-search-button'
              size="regular"
              onClick={searchRowCell}
            >
              Search
            </SecondaryButton>
            <SecondaryButton
              name='ifms-table-filter-search-cancel-button'
              size="regular"
              onClick={cancel}
            >
              CANCEL
            </SecondaryButton>
          </div>
        </div>
      </IfmsModal>
    </div>
  );
}

export default React.memo(TableSearch);